import { combineReducers } from "redux";
import getSnapshotDataReducer from "./getFullSnapshotDataReducer";
import getPreviousSnapshotDataReducer from "./getPreviousSnapshotDataReducer";
import getValidateSnapshotReducer from "./getValidateSnapshotReducer";
import getSnapshotTypeReducer from "../getSnapshotTypeDisplay/getSnapshotType";
import getPreviousSnapshotDataInternalReducer from "./getPreviousSnapshotDataInternalReducer";


const snapshotDataReducer = combineReducers({
    getSnapshotData: getSnapshotDataReducer,
    getPreviousSnapshotData: getPreviousSnapshotDataReducer,
    getPreviousSnapshotDataInternal: getPreviousSnapshotDataInternalReducer,
    getValidateSnapshot: getValidateSnapshotReducer,
    getSnapshotType: getSnapshotTypeReducer
});

export default snapshotDataReducer;